import { EType } from '../../../../types/villagePromotions';
import * as styles from '../styles.css';

export function getVillagePromotionClassName(type: EType): string {
  switch (type) {
    case EType.Sale:
      return styles['discount'];
    case EType.Mortgage:
      return styles['mortgage'];
    case EType.Bonus:
      return styles['bonus'];
    case EType.MaternalCapital:
      return styles['maternal-capital'];
    case EType.MilitaryMortgage:
      return styles['military-mortgage'];
  }
}
